import React from 'react';

import './contact-form.scss';
import cs from "classnames";
import ContactFormInput from '../../contact-form-input/contact-form-input';



const ContactFormRu = ({ formId, title, subTitle, inputCompanyText }) => {
  const [ success, setSuccess ] = React.useState(false);
  const [ error, setError ] = React.useState(false);
  const [ company, setCompany ] = React.useState();
  const [ project, setProject ] = React.useState();
  const [ email, setEmail ] = React.useState();
  const [ phone, setPhone ] = React.useState();
  const [ name, setName ] = React.useState();
  const width = window.innerWidth;


  const onSubmit = event => {
    event.preventDefault();

    if (window.ym) {
      if (window.location.pathname === '/competencies/interface/apps/') {
        window.ym(5320750,'reachGoal','form_1');
      } else if (window.location.pathname === '/competencies/interface/') {
        window.ym(5320750,'reachGoal','form_2');
      }
    }

    const url = '/svalka/api/expressform/';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ company, project, email, phone, name })
    };

    fetch(url, requestOptions)
        .then((response => response.json()))
        .then((json) => {
          const { ok, text } = json;
          if (ok) {
            setSuccess(true);
            setError(false);
            if (window.ym) {
              window.ym(5320750,'reachGoal','com_order_sent');
            }
            return;
          }

          // if (text) {
          //   window.alert(text);
          //   return;
          // }

          setError(true);
          setSuccess(false);
        })
        .catch(() => {
          setError(true);
          setSuccess(false);
        })
  }

  return (
      <React.Fragment>
        <section className="contactus" id="contact">
          <div
              id="l-express-form-container"
              className={cs(
                  "contactus_form",
                  {
                    "success": success,
                    "error": error
                  }
              )}
          >
            <h2 className="header" dangerouslySetInnerHTML={{ __html: title || 'Заказ дизайна' }} />
            <p dangerouslySetInnerHTML={{ __html: subTitle || 'Достаточно рассказать о&nbsp;своем проекте&nbsp;&mdash; мы&nbsp;свяжемся, чтобы все обсудить' }}></p>
            <form onSubmit={onSubmit}>
              <ContactFormInput
                  placeholder={ inputCompanyText ? inputCompanyText : 'Название компании' }
                  name="company"
                  onChange={setCompany}
              />
              <ContactFormInput
                  placeholder={width > 600 ? "Несколько слов о проекте и приблизительный бюджет" : "Несколько слов о проекте"}
                  name="project"
                  onChange={setProject}
              />
              <ContactFormInput
                  placeholder="Электропочта"
                  name="email"
                  onChange={setEmail}
              />
              <ContactFormInput
                  placeholder={width > 600 ? "Телефон или любой удобный мессенджер" : "Телефон или мессенджер"}
                  name="phone"
                  onChange={setPhone}
              />
              <ContactFormInput
                  placeholder="Имя"
                  name="name"
                  onChange={setName}
              />
              <button type="submit">Отправить заявку</button>
              <input type="hidden" name="form_id" value={formId} />
            </form>
            <div className="contactus_success">
              <h2>Спасибо, заявка уже у&nbsp;нас. <br/> Скоро выйдем на&nbsp;связь.</h2>
            </div>
            <div className="contactus_error">
              <h2>Что-то пошло не так, попробуйте еще раз!</h2>
            </div>
          </div>
        </section>
      </React.Fragment>
  );
}

export default ContactFormRu;
